// extracted by mini-css-extract-plugin
export var askAiIcon = "_nn-j";
export var category = "_nn-9";
export var categoryHeader = "_nn-e";
export var container = "_nn-0";
export var group = "_nn-a";
export var groupItems = "_nn-f";
export var groupSeparator = "_nn-k";
export var loading = "_nn-1";
export var noResults = "_nn-3";
export var placeholder = "_nn-2";
export var resultContent = "_nn-5";
export var resultIcon = "_nn-c";
export var resultItem = "_nn-g";
export var resultMeta = "_nn-8";
export var resultSubtitle = "_nn-7";
export var resultSuffix = "_nn-i";
export var resultTitle = "_nn-6";
export var resultsList = "_nn-4";
export var searchGroup = "_nn-d";
export var selected = "_nn-h";
export var subgroup = "_nn-b";